
import { Component, forwardRef, OnInit,ChangeDetectorRef, AfterViewInit, Input, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-searchable-multi-selectbox',
  templateUrl: 'searchable-multi-selectbox.component.html',
  styleUrls: ['searchable-multi-selectbox.component.scss'],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting:forwardRef(()=>HHSGSharedSearchableMultiSelectboxComponent),
      multi:true,
    }
    ]
})

export class HHSGSharedSearchableMultiSelectboxComponent implements OnInit,AfterViewInit,ControlValueAccessor {
  value : string[];
  maxItems: number = 10;
  isShowErrorMessage: boolean = false;
  @Input() disabled = false;
  @Input() dataSource: any;  
  @Input() checkBoxChangeValue: boolean;
  @Input() isRequired = false;
  @Output() showErrorMessage: EventEmitter<boolean>  = new EventEmitter();

  onChange : (dataSource: any) =>void
  onTouch : () => void;
  
  constructor(private _ChangeDetectorRef: ChangeDetectorRef) { }
  
  onValueChanged(e) {
    if(e.value != null && e.value.length > 0)
    {
        this.showErrorMessage.emit(false);
    }
    else if(e.previousValue != null && e.previousValue.length == 1 && this.checkBoxChangeValue)
    {
      this.showErrorMessage.emit(true);
    }
    if(e.value != null && e.value.length > this.maxItems){
        let newValue = e.value.slice(0, this.maxItems); 
        e.component.option("value", newValue);
    } 
  this.onChange(e);
}

  writeValue(obj:any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange =fn
  }

  registerOnTouched(fn: any): void {
    this.onTouch=fn
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

ngAfterViewInit(): void {
  this._ChangeDetectorRef.detectChanges();
}

async ngOnInit() {}

}

